import { client } from '@/client';

export function getUserList(params) {
  return client.get('/api/sys_user_service/listUser', params);
}

// 删除用户
export function deleteUser(params) {
  return client.post('/api/sys_user_service/deleteUser', params);
}

// 更新用户
export function updateUser(params) {
  return client.post('/api/sys_user_service/putUser', params);
}

// 新增用户
export function createUser(params) {
  return client.post('/api/sys_user_service/createUser', params);
}

// 修改状态
export function changeUserStatus(params) {
  return client.post('/api/sys_user_service/changeUserStatus', params);
}
